const ddados = {
  Titulo: 'Imprimir Solicitação',
  Campos: {
    CpfCnpj: {
      Tipo: 'mask',
      Mascara: 'CPFCNPJ',
      Label: 'CPF / CNPJ',
      Tooltip: 'CPF / CNPJ',
      Obrigatorio: true,
    },
  },
};

export { ddados };
